module.exports = __webpack_public_path__ + "static/josianchevalier-7ed9b0d748db0643d5d4c08bf9a6b5a6.png";